module.exports = __webpack_public_path__ + "img/thumbnail-reef2.ba58983d.jpg";